import EventStats from '@/screens/EventStats';

export default function PrivateTabsOrganizationScheduleScheduleAEventIdStatsRoute() {
  return <EventStats />;
}
